export const PRODUCTS = [
    {
        id: "caloo",
        name: "Caloo",
        priceId: "price_1SQTiaHneiZN0NYTiiSdAJsx",
        image: "https://horizons-cdn.hostinger.com/a111e276-6ba3-4462-bf41-a8d0290cd8d5/captura-de-pantalla-2025-09-15-a-las-15.08.24-xMDcJ.png",
    },
    {
        id: "oorenji",
        name: "Oorenji",
        priceId: "price_1QxPP4HneiZN0NYTQh5GU1CA",
        image: "https://horizons-cdn.hostinger.com/a111e276-6ba3-4462-bf41-a8d0290cd8d5/captura-de-pantalla-2025-09-15-a-las-15.09.17-LPIYa.png",
    },
    {
        id: "kit",
        name: "Kit",
        priceId: "price_1SRsh6HneiZN0NYT9FmX3T36",
        image: "https://horizons-cdn.hostinger.com/a111e276-6ba3-4462-bf41-a8d0290cd8d5/firefly-a-futuristic-clean-and-professional-hero-realistic-image-for-a-biotech-startup-in-precision-kedQ3.jpg",
    },
];
